"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _mapBackendColorToTheme = require("./mapBackendColorToTheme");
Object.keys(_mapBackendColorToTheme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapBackendColorToTheme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapBackendColorToTheme[key];
    }
  });
});
//# sourceMappingURL=index.js.map